import React, { memo, useEffect, useRef, useState } from 'react';
import { Spinner, Card } from 'react-bootstrap';
import GridLayout from 'react-grid-layout';
import PropTypes from 'prop-types';
import ZingChart from './ZingChart';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import '../assets/styles/index.scss';

const ZingDashboard = ({ apiKey, token, loadingDashboard, loadingValidation, dashboardData, where }) => {
  const layout =
    dashboardData?.questions.map(q => ({
      i: q.question._id,
      x: q.question.startX,
      y: q.question.startY,
      w: q.question.width,
      h: q.question.height,
      minW: q.question.minWidth,
      minH: q.question.minHeight,
      static: true,
      isBounded: true,
    })) || [];

  const parentRef = useRef(); // Create a ref for the parent container
  const [gridWidth, setGridWidth] = useState(1200); // Set default width, adjusted dynamically

  // Update the grid width based on the parent container's size
  useEffect(() => {
    if (parentRef.current) {
      setGridWidth(parentRef.current.offsetWidth); // Dynamically set the grid width to match the parent container
    }

    const handleResize = () => {
      if (parentRef.current) {
        setGridWidth(parentRef.current.offsetWidth); // Adjust the grid width on window resize
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loadingDashboard || loadingValidation) {
    return (
      <div
        className="zing-data-body mb-3 mt-2"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div ref={parentRef} style={{ width: '100%', overflow: 'hidden' }}>
      <h5 style={{ textAlign: 'left', marginLeft: '11px', marginTop: '1rem', marginBottom: '1rem' }}>
        {dashboardData?.dashboardTitle}
      </h5>
      <GridLayout
        className="zing-layout"
        layout={layout}
        cols={12}
        rowHeight={100}
        width={gridWidth}
        isDraggable={false}
        isResizable={false}
        autoSize={true}
        compactType="vertical"
        preventCollision={true}>
        {dashboardData?.questions.map(q => (
          <Card
            key={q.question._id}
            data-grid={layout.find(l => l.i === q.question._id)}
            className="py-4 px-2"
            style={{ maxWidth: '100%', margin: '0' }}>
            <p>{q.question.questionText}</p>
            <ZingChart
              apiKey={apiKey}
              token={token}
              questionData={{ questionId: q.question._id, questionText: q.question.questionText }}
              chartType={q.question.chartType}
              jobId={q.question.chartType === 'DataTable' ? q.tableJobId.id : q.chartJobId.id}
              forDashboard={true}
            />
          </Card>
        ))}
      </GridLayout>
    </div>
  );
};

ZingDashboard.propTypes = {
  apiKey: PropTypes.string.isRequired,
  token: PropTypes.string,
  where: PropTypes.string,
  loadingDashboard: PropTypes.bool,
  loadingValidation: PropTypes.bool,
  dashboardData: PropTypes.object,
};

export default memo(ZingDashboard);
